var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M14.9496 11.6997C14.9604 10.8564 15.1844 10.0296 15.6007 9.29619C16.0169 8.56277 16.6119 7.94655 17.3304 7.50488C16.874 6.85308 16.2719 6.31668 15.5719 5.93827C14.872 5.55987 14.0934 5.34989 13.2981 5.325C11.6016 5.14693 9.95692 6.34017 9.09241 6.34017C8.21116 6.34017 6.88011 5.34268 5.44678 5.37217C4.51966 5.40213 3.61612 5.67172 2.82417 6.1547C2.03223 6.63768 1.3789 7.31756 0.927841 8.12811C-1.02606 11.511 0.431375 16.4827 2.30305 19.2171C3.23948 20.5561 4.33391 22.0518 5.76594 21.9987C7.16727 21.9406 7.69064 21.1052 9.38217 21.1052C11.058 21.1052 11.549 21.9987 13.0101 21.965C14.5138 21.9406 15.4612 20.6201 16.3648 19.2684C17.0376 18.3143 17.5554 17.2599 17.8988 16.1441C17.0252 15.7746 16.2797 15.1561 15.7552 14.3658C15.2308 13.5754 14.9506 12.6482 14.9496 11.6997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M12.1901 3.52653C13.01 2.5423 13.4139 1.27724 13.3161 0C12.0635 0.13156 10.9065 0.730215 10.0755 1.67668C9.66924 2.13906 9.35808 2.67697 9.15981 3.25968C8.96155 3.84238 8.88007 4.45845 8.92004 5.07266C9.54656 5.07911 10.1664 4.94331 10.7328 4.6755C11.2992 4.40768 11.7975 4.01483 12.1901 3.52653Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleSvg);
export default __webpack_public_path__ + "static/media/AppleSvg.a39fdd478dd951c4ec71a02d5d8e7f12.svg";
export { ForwardRef as ReactComponent };